import * as React from 'react';

type SubmitButtonProps = {
  text: string;
  disabled: boolean;
  inProgress: boolean;
  className?: string;
  dataTestId?: string;
  hidden?: boolean;
};

export default function SubmitButton({
  text,
  disabled,
  inProgress,
  className,
  dataTestId,
  hidden = false,
}: SubmitButtonProps) {
  return (
    <div className="row justify-content-center" hidden={hidden}>
      <div className="col-10 col-lg-8 text-center">
        <button type="submit" className={className} disabled={disabled} data-testid={dataTestId}>
          {inProgress && (
            <span
              data-testid={`spinner-${dataTestId}`}
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          {text}
        </button>
      </div>
    </div>
  );
}
